import api from "@services/api";

export const getZenithSubscriberById = async (id: string) => {
  const { data } = await api.get(`/subscribers/${id}`);
  return data.subscriber;
};
